<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-8>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("seting.text1") }}</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title>
                <v-layout row wrap>
                  <v-flex xs10 lg3 ml-4></v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs7 lg4 mr-6>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text>
                <template>
                  <div>
                    <v-data-table
                      :headers="headers"
                      :search="Search"
                      :items="dataMenu"
                      :page.sync="page"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                      class="rounded-lg"
                      @page-count="pageCount = $event"
                    >
                      <template v-slot:[`item.menu`]="{ item }">
                        <div v-if="$t('default') === 'th'">
                          {{ item.menu }}
                        </div>
                        <div v-else>
                          {{ item.menuEng }}
                        </div>
                      </template>
                      <template v-slot:[`item.UpdateAt`]="{ item }">
                        <div v-if="$t('default') === 'th'">
                          {{ item.UpdateAt }}
                        </div>
                        <div v-else>
                          {{ item.UpdateAtEng }}
                        </div>
                      </template>
                      <template v-slot:[`item.config`]="{ item }">
                        <v-layout>
                          <v-flex>
                            <v-btn
                              v-if="item.config"
                              rounded
                              small
                              color="success"
                              class="mr-0"
                              :loading="item.loading"
                              dark
                              @click="Config_Menu(item)"
                            >
                              <v-icon left> mdi-eye </v-icon
                              >{{ $t("seting.text5") }}</v-btn
                            >
                            <v-btn
                              v-else
                              rounded
                              small
                              color="grey"
                              class="mr-0"
                              :loading="item.loading"
                              dark
                              @click="Config_Menu(item)"
                            >
                              <v-icon left> mdi-eye-lock-open </v-icon
                              >{{ $t("seting.text6") }}</v-btn
                            >
                          </v-flex>
                        </v-layout>
                      </template>
                    </v-data-table>
                  </div>
                </template>
              </v-card-text>
            </v-card>
            <!-- {{ GetListMenu }}
            {{ dataMenu }} -->
            <div class="text-center pt-2">
              <v-pagination
                :total-visible="7"
                color="#077893"
                v-model="page"
                :length="pageCount"
              ></v-pagination>
              <!-- <v-text-field :value="itemsPerPage" label="Items per page" type="number" min="-1" max="15"
                    @input="itemsPerPage = parseInt($event, 10)"></v-text-field> -->
            </div>
          </v-flex>
        </v-layout>
        <v-overlay :value="loadSendPetition" :opacity="opacity"></v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { watch } from "vue";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {},
  data: function () {
    return {
      Search: "",
      page: 1,
      opacity: 0,
      pageCount: 0,
      itemsPerPage: 10,
      ItemPerPage: 10,
      Page: 1,
      loadSendPetition: false,
      GetListMenu: [],
      dataMenu: [],
      dataMenuEng: [],
      config: [],
    };
  },
  computed: {
    ...mapGetters(["Profile"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },

    headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          align: "center",
          sortable: false,
          value: "no",
        },
        { text: this.$i18n.t("seting.text2"), value: "menu", sortable: false },
        {
          text: this.$i18n.t("seting.text3"),
          value: "UpdateAt",
          sortable: false,
          align: "center",
        },
        {
          text: this.$i18n.t("seting.text4"),
          value: "config",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  watch: {},
  mounted() {
    this.Fn_GetListMenu();
  },
  methods: {
    Fn_GetListMenu() {
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "config-notify/GetListMenu",
          payload
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.GetListMenu = [response.data.Message];
            this.MenuConsentTh = response.data.Message.MenuConsentTh;
            this.MenuGroupConsentTh = response.data.Message.MenuGroupConsentTh;
            this.MenuPolicyTh = response.data.Message.MenuPolicyTh;
            this.MenuTemplateEmailTh =
              response.data.Message.MenuTemplateEmailTh;
            this.MenuConsentEng = response.data.Message.MenuConsentEng;
            this.MenuGroupConsentEng =
              response.data.Message.MenuGroupConsentEng;
            this.MenuPolicyEng = response.data.Message.MenuPolicyEng;
            this.MenuTemplateEmailThEng =
              response.data.Message.MenuTemplateEmailThEng;
            this.UpdateAt = response.data.Message.UpdateAt;
            this.UpdateAtEng = response.data.Message.UpdateAtEng;
            this.Consent = response.data.Message.Consent;
            this.GroupConsent = response.data.Message.GroupConsent;
            this.Policy = response.data.Message.Policy;
            this.TemplateEmail = response.data.Message.TemplateEmail;
            (this.dataMenu = [
              {
                menu: this.MenuConsentTh,
                UpdateAt: this.UpdateAt,
                config1: this.Consent,
                config: this.Consent,
                menuEng: this.MenuConsentEng,
                UpdateAtEng: this.UpdateAtEng,
              },
              {
                menu: this.MenuGroupConsentTh,
                UpdateAt: this.UpdateAt,
                config2: this.GroupConsent,
                config: this.GroupConsent,
                menuEng: this.MenuGroupConsentEng,
                UpdateAtEng: this.UpdateAtEng,
              },
              {
                menu: this.MenuPolicyTh,
                UpdateAt: this.UpdateAt,
                config3: this.Policy,
                config: this.Policy,
                menuEng: this.MenuPolicyEng,
                UpdateAtEng: this.UpdateAtEng,
              },
              {
                menu: this.MenuTemplateEmailTh,
                UpdateAt: this.UpdateAt,
                config4: this.TemplateEmail,
                config: this.TemplateEmail,
                menuEng: this.MenuTemplateEmailThEng,
                UpdateAtEng: this.UpdateAtEng,
              },
            ]),
              (this.fix = [
                { config: this.Consent },
                { config: this.GroupConsent },
                { config: this.Policy },
                { config: this.TemplateEmail },
              ]);
            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1;
            var nextPage = startPage + this.dataMenu.length;

            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.dataMenu) {
              this.dataMenu[j]["no"] = number[j];
            }
            for (var j in this.dataMenu) {
              this.dataMenu[j]["loading"] = false;
            }
            for (var j in this.dataMenuEng) {
              this.dataMenuEng[j]["no"] = number[j];
            }
            for (var j in this.dataMenuEng) {
              this.dataMenuEng[j]["loading"] = false;
            }
          } else
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Config_Menu(item) {
      item.config = !item.config;
      if (item.no === 1) {
        this.fix[0].config = item.config;
      } else {
        this.fix[0].config = this.fix[0].config;
      }
      if (item.no === 2) {
        this.fix[1].config = item.config;
      } else {
        this.fix[1].config = this.fix[1].config;
      }
      if (item.no === 3) {
        this.fix[2].config = item.config;
      } else {
        this.fix[2].config = this.fix[2].config;
      }
      if (item.no === 4) {
        this.fix[3].config = item.config;
      } else {
        this.fix[3].config = this.fix[3].config;
      }
      this.loadSendPetition = true;
      item.loading = true;
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        Consent: this.fix[0].config,
        GroupConsent: this.fix[1].config,
        Policy: this.fix[2].config,
        TemplateEmail: this.fix[3].config,
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "config-notify/InsertConfigMenu",
          payload
        )
        .then((response) => {
          this.loadSendPetition = false;
          item.loading = false;

          if (response.data.Status === "OK") {
            if (item.config === true) {
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("seting.text5"),
              });
            } else if (item.config === false) {
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("seting.text6"),
              });
            }
          } else
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
        })
        .catch((error) => {
          this.loadSendPetition = false;
          item.loading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
  },
};
</script>
<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
